<router-outlet></router-outlet>
<p-toast position="bottom-left" class="toast-root">
  <ng-template let-message #message>
    <div class="toast-template">
      <div class="toast-template-icon-wrap">
        <i class="toast-template-icon" [class]="toast_icon(message?.severity)" aria-hidden="true"></i>
      </div>
      <div class="toast-template-main">
        @if (message.summary) {
        <p class="toast-template-title">{{ message.summary }}</p>
        }
        @if (message.detail) {
        <p class="toast-template-detail">{{ message.detail }}</p>
        }
      </div>
    </div>
  </ng-template>
</p-toast>